function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
const EasySchemaFieldKeyMap = {
  string: "String",
  object: "Object",
  array: "Array",
  boolean: "Boolean",
  date: "Date",
  datetime: "DateTime",
  void: "Void",
  number: "Number"
};
function renderSchema(key, name, schema, EasySchemaFieldMap) {
  const { type, properties, items } = schema, props = _object_without_properties(schema, [
    "type",
    "properties",
    "items"
  ]);
  if (!type || typeof type !== "string") {
    return null;
  }
  const ElementKey = EasySchemaFieldKeyMap[type];
  const Element = EasySchemaFieldMap[ElementKey];
  if (!Element) {
    return null;
  }
  const children = renderChildren(schema, EasySchemaFieldMap);
  return /* @__PURE__ */ React.createElement(Element, _object_spread_props(_object_spread({}, props), {
    name,
    key
  }), children);
}
function renderChildren(schema, EasySchemaFieldMap) {
  const { type, properties, items } = schema;
  if (type !== "object" && type !== "array" && type !== "void") {
    return;
  }
  if (!properties && !items) {
    return;
  }
  const children = Object.entries(properties !== null && properties !== void 0 ? properties : []).map(([childName, childSchema]) => renderSchema(childName, childName, childSchema, EasySchemaFieldMap));
  if (type === "array" && items) {
    var _children;
    (_children = children) === null || _children === void 0 ? void 0 : _children.unshift(renderSchema("$$$items", void 0, items, EasySchemaFieldMap));
  }
  return children;
}
export function renderSchemaFieldChildren(rootSchema, EasySchemaFieldMap) {
  return renderChildren(rootSchema, EasySchemaFieldMap);
}
